import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledFilterHeading = styled.p`
    ${setFontVariant("sectionTitle", colorsPalettes.carbon[400])};
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
`;
